import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
export const CRM_OBJECT_SEARCH_BY_ID_FIELD_NAME = 'automation_ui_log_events_crmObjectSearch';
export const CRM_OBJECT_SEARCH_BY_ID = registerQuery({
  fieldName: CRM_OBJECT_SEARCH_BY_ID_FIELD_NAME,
  args: ['objectTypeId', 'objectId'],
  fetcher: ({
    objectTypeId,
    objectId
  }) => {
    const data = {
      objectTypeId,
      count: 1,
      offset: 0,
      query: '',
      requestOptions: {
        allPropertiesFetchMode: 'latest_version',
        includeAllProperties: true
      },
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          value: objectId,
          property: 'hs_object_id'
        }]
      }]
    };
    return http.post(`crm-search/search`, {
      data
    }).then(({
      results
    }) => results && results.length ? results[0] : null).catch(e => {
      Raven.captureMessage('Query failed: automation_ui_log_events_crmObjectSearch');
      throw e;
    });
  }
});